import React from "react";
import Select from "react-select";
import NavHeader from "./NavHeader";
import NavRow from "./NavRow";
import { nuevoEquipoDeTorneo } from "./equipos";

// Lista de equipos participantes del torneo. Alta por react-select; cada equipo
// abre su roster (TeamScreen) en drill-down.
//
// La baja la resuelve el host (onRemoveTeam): además de confirmarla, tiene que sacar
// al equipo de las zonas, listas de fe y partidos de todas las ruedas, que desde acá
// no se ven.
export default function TeamsScreen({ teams, equipos, jugadores, onChange, onRemoveTeam, onOpenTeam, onBack }) {
  const addTeam = (option) => {
    if (!option || !option.label) return;

    // Sacar el equipo elegido de las opciones para que no se pueda repetir.
    const index = equipos.findIndex((e) => e.value === option.value);
    if (index >= 0) equipos.splice(index, 1);

    // El equipo se agrega con la lista de fe precargada.
    onChange([...teams, nuevoEquipoDeTorneo(option, jugadores)]);
  };

  return (
    <div className="screen-slide">
      <NavHeader title="Equipos" subtitle={teams.length + " cargados"} onBack={onBack} />

      <div className="card mb-3">
        <div className="card-body">
          <label className="font-weight-bold" style={{ fontSize: "0.875rem" }}>
            Agregar Equipo
          </label>
          <Select
            isSearchable={true}
            placeholder="Buscá un equipo..."
            classNamePrefix="react-select"
            name="selectedTeam"
            value={null}
            onChange={addTeam}
            options={equipos}
            noOptionsMessage={() => "Sin equipos disponibles"}
          />
        </div>
      </div>

      {teams.length === 0 ? (
        <div className="empty-state">
          <svg className="empty-state-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <p className="mb-1 font-weight-bold">No hay equipos</p>
          <p className="text-muted" style={{ fontSize: "0.875rem" }}>
            Agregá el primer equipo para comenzar a construir tu torneo. Podrás cargar hasta 14 jugadores por equipo.
          </p>
        </div>
      ) : (
        teams.map((team, index) => (
          <NavRow
            key={team.id}
            title={team.name || "Equipo " + (index + 1)}
            badges={[{ label: team.players.length + "/14 jugadores", variant: "arhock" }]}
            compact
            onClick={() => onOpenTeam(team.id)}
            onDelete={() => onRemoveTeam(team.id)}
          />
        ))
      )}
    </div>
  );
}
